import { Trophy } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface PersonalBestIconProps {
  type: 'weight' | 'reps' | 'distance' | 'pace';
  className?: string;
}

export function PersonalBestIcon({ type, className }: PersonalBestIconProps) {
  const getLabel = () => {
    switch(type) {
      case 'weight': return 'Weight';
      case 'reps': return 'Reps';
      case 'distance': return 'Distance';
      case 'pace': return 'Pace';
      default: return 'PB';
    }
  };

  return (
    <Badge 
      variant="default" 
      className={`bg-gradient-gold text-gold-foreground text-xs px-2 py-1 font-bold shadow-gold animate-pulse ${className}`}
    >
      <Trophy className="h-3 w-3 mr-1" />
      PB {getLabel()}!
    </Badge>
  );
}